module.exports = __webpack_public_path__ + "img/9.69b442df.png";